import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import crumbs from './crumbs'
import siteVersions from '@/app/site-versions/store'
import products from '@/app/products/store'
import riders from '@/app/riders/store'
import ridersCategories from '@/app/riders/categories/store'
import ridersDisciplines from '@/app/riders/disciplines/store'
import ridersMedia from '@/app/riders/media/store'
import fighters from '@/app/fighters/store'
import fightersCategories from '@/app/fighters/categories/store'
import fightersMedia from '@/app/fighters/media/store'
import rappers from '@/app/rappers/store'
import rappersMedia from '@/app/rappers/media/store'
import news from '@/app/news/store'
import newsCategories from '@/app/news/categories/store'
import newsMedia from '@/app/news/media/store'
import socials from '@/app/socials/store'
import contacts from '@/app/contacts/store'
import cities from '@/app/cities/store'
import citiesCountries from '@/app/cities/countries/store'
import feedback from '@/app/feedback/store'
import feedbackSubject from '@/app/feedback/subject/store'
import faqs from '@/app/faqs/store'
import faqsCategories from '@/app/faqs/categories/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    crumbs,
    siteVersions,
    products,
    riders,
    ridersCategories,
    ridersDisciplines,
    ridersMedia,
    fighters,
    fightersCategories,
    fightersMedia,
    rappers,
    rappersMedia,
    news,
    newsCategories,
    newsMedia,
    socials,
    contacts,
    cities,
    citiesCountries,
    feedback,
    feedbackSubject,
    faqs,
    faqsCategories
  }
})
